import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'

import { TextBox } from 'atoms/TextBox'

export interface ITextBoxWithChildrenMaxLines2 extends ITextBoxProps {}

export const TextBoxWithChildrenMaxLines2 = ({
  verticalGap,
  children,
  maxLines = 2,
}: ITextBoxWithChildrenMaxLines2): JSX.Element => {
  return (
    <TextBox verticalGap={verticalGap} maxLines={maxLines}>
      {children}
    </TextBox>
  )
}
